import { ICmsModelCmsData } from '@df/catalog/cms/cms-model.interface';
import { IModelDataV1, IModelDataV3 } from '@df/catalog/model';

export namespace Catalog {
    //////////////////////////////////////////
    //
    // Interfaces Attribute
    //
    /////////////////////////////////////////

    export interface IAttributeData extends IModelDataV1 {
        code: string;
        configurable: boolean;
        filterable?: 1 | 0;
        frontend_input?: string;
        indexable?: 1 | 0;
        isSwatch: boolean;
        label: string;
        options?: IAttributeOption[];
        position: number;
        range: boolean;
        // default : num
    }

    export interface IAttributeOption {
        value: number;
        label: string | number; // if label is numeric it will be converted to int or float
        hasColor?: boolean;
        hasImage?: boolean;
        swatch?: string;
        group?: string | number;
        count?: number;
    }

    export interface IAttributeOptionGroup extends IAttributeOption {
        // parent props are taken from first option
        values: number[];
        label: string | number;
        position: number;
    }

    //////////////////////////////////////////
    //
    // Interfaces
    // Customer Attribute
    //
    /////////////////////////////////////////

    export interface ICustomerAttributeData extends IModelDataV1 {
        code: string;
        filterable?: 1 | 0;
        range: boolean;
        indexable?: 1 | 0;
        label: string;
        options?: ICustomerAttributeOption[];
        frontend_input: ICustomerAttributeInput;
    }

    export interface ICustomerAttributeOption {
        value: number;
        label: string;
    }

    export enum ICustomerAttributeInput {
        boolean = 'boolean',
        select = 'select',
        multiselect = 'multiselect',
        text = 'text',
        date = 'date'
    }

    //////////////////////////////////////////
    //
    // Interfaces
    // Block
    //
    /////////////////////////////////////////

    /**
     * Verbosity 1 data
     */
    export interface IBlockData<D = any> extends IModelDataV1 {
        id: number;
        url: string;
        name: string;
        content: D & IStyles;
        apiMeta?: IApiMeta;
    }

    export interface IApiMeta {
        relations: IDataRelation[];
    }

    export interface IStyles {
        styles: IStylesValues;
    }

    export interface IStylesValues {}

    export interface IDataRelation {
        /**
         * Path to field
         */
        path: string;
        /**
         * Relation type (page, product, block, ...)
         */
        type: string;
    }

    /**
     * Verbosity 1 data
     */
    export interface IBlockDataV4<D = any> extends IBlockData<D> {
        _cms: ICmsBlockCmsData;
    }

    export interface ICmsBlockCmsData extends ICmsModelCmsData {
        scope?: 'website' | string;
    }

    //////////////////////////////////////////
    //
    // Interfaces
    // Finder
    //
    /////////////////////////////////////////

    export interface IFindableLocateOptions {
        limit?: number;
        maxDistance?: number;
        address: string;
        country?: string;
        verbosity?: number;
    }

    export interface IFindableLocateCoordsOptions {
        limit?: number;
        maxDistance?: number;
        latitude: number;
        longitude: number;
        verbosity?: number;
    }

    export declare type IFinderData = IFinderDataV1 | IFinderDataV3;

    export interface IFinderDataV1 extends IModelDataV1 {
        id: number;
        /**
         * Latitude of hub
         */
        latitude?: number;
        /**
         * Longitude of hub
         */
        longitude?: number;
        /**
         * Distance to hub from given address
         */
        distance?: number;

        country_id?: string;

        sort_order?: number;
    }

    export interface IFinderDataV3 extends IFinderDataV1, IModelDataV3 {
        id: number;
        url?: string;
    }
}
